export const addressProps = {
  addressUseType: {
    default: 0
  },
  hideSystemAddress: {
    default: false
  },
  addressListDialogTitle: {
    default: '选择地址'
  },
  size: {},
  required: {
    default: false
  },

  addressEnableContactDetails: {
    default: false
  },
  disabled: {
    default: false
  },
  address: {
    type: Object,
    default: () => {
      return {
        id: '',
        address: ''
      }
    }
  },
  // 纯文本
  isPureText: {
    type: Boolean,
    default: true
  },
  addressEnableContactPerson: {
    type: Boolean,
    default: false
  },
  addressEnableZipCode: {
    type: Boolean,
    default: false
  }
}
